var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartActive2422 = function SvgHeartActive2422(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#heart_active_24_22_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FD6464",
    d: "M10.002 16.342c.716.578 1.4 1.13 1.998 1.658a65 65 0 0 1 1.922-1.587C17.115 13.845 21 10.718 21 6.801a4.77 4.77 0 0 0-1.455-3.426A4.9 4.9 0 0 0 16.05 2a5.44 5.44 0 0 0-3.146.98 5.4 5.4 0 0 0-.904.798 5.4 5.4 0 0 0-.904-.798A5.44 5.44 0 0 0 7.95 2a4.9 4.9 0 0 0-3.495 1.374A4.77 4.77 0 0 0 3 6.8c0 3.887 3.827 6.977 7.002 9.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.6,
    d: "m10.509 15.723-.005-.004c-1.599-1.291-3.289-2.659-4.586-4.172S3.8 8.47 3.8 6.8a3.97 3.97 0 0 1 1.212-2.852 4.1 4.1 0 0 1 2.923-1.148h.02a4.64 4.64 0 0 1 2.682.835q.421.294.77.68L12 4.97l.593-.656q.349-.385.77-.679a4.64 4.64 0 0 1 2.683-.835h.019a4.1 4.1 0 0 1 2.923 1.148A3.97 3.97 0 0 1 20.2 6.8c0 1.684-.834 3.264-2.148 4.79s-3.023 2.906-4.631 4.2l-.004.003-.004.004c-.486.39-.963.775-1.41 1.15-.472-.399-.977-.806-1.49-1.22z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "heart_active_24_22_svg__a",
    width: 23,
    height: 21,
    x: 0.8,
    y: 0.7,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15063_64835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_15063_64835",
    result: "shape"
  })))));
};
export default SvgHeartActive2422;